<template>
  <layouts>
    <template #content>
      <zloading v-if="loading"></zloading>
      <div v-else class="bg-gray-100 h-auto overflow-x-scroll">
        <div class="container px-4 py-10 mx-auto">
          <board
            :data="data.data"
            :dataAgen="dataAgen"
            :dataKurir="dataKurir"
            :dataCabang="dataCabang"
            :dataWarehouse="dataWarehouse"
            :dataMitra="dataMitra"
            :meta="data.meta"
            :PageNavHandler="pageNavHandler"
            :TableInputSearchHandler="tableInputSearchHandler"
            :totalOrder="totalOrder"
            :totalShipmentFee="totalShipmentFee"
            :viewMode="viewMode"
            @viewModeChange="viewMode = $event"
            @show="detailOrder"
            @selectRangeDate="selectRangeDate"
            @resetData="resetData"
            @refreshData="refreshData"
            @filterStartDate="filterStartDate"
            @filterEndDate="filterEndDate"
            @filterCourier="filterCourier"
            @filterDestination="filterDestination"
            @filterStatusOrder="filterStatusOrder"
            @filterLimitOrder="filterLimitOrder"
            @filterManifestDate="filterManifestDate"
            @filterAgen="filterAgen"
            @filterAdmin="filterAdmin"
            @filterPaymentMethod="filterPaymentMethod"
            @filterBranch="filterBranch"
            @searchNoOrder="searchNoOrder"
            @searchAWBNo="searchAWBNo"
            @searchAll="searchAllQuery"
          >
          </board>
        </div>
        <!-- Detail Data Modal -->
        <transition
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="opacity-100"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-show="detailModal"
            class="fixed inset-0 transition-opacity z-10"
            aria-hidden="true"
          >
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>
        </transition>
        <transition
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="opacity-100 translate-y-0 sm:scale-100"
          leave-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <detailDataModal
            v-show="detailModal"
            title="Detail Transaksi International"
            desc="Informasi transaksi pengiriman ke luar negeri"
            @close="
              detailModal = false;
              dataSelected = [];
            "
          >
            <dl>
              <div
                class="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  No Order/Shipment Number
                </dt>
                <dd
                  class="mt-1 text-xs text-gray-900 font-semibold sm:mt-0 sm:col-span-2"
                >
                  <div class="flex items-center">
                    {{
                      dataSelected.shipment_number
                        ? dataSelected.shipment_number
                        : "-"
                    }}
                    <button
                      v-clipboard:copy="dataSelected.shipment_number"
                      v-clipboard:success="onCopyShipmentNumber"
                      v-clipboard:error="onErrorShipmentNumber"
                      class="bg-blue-500 ml-3 relative inline-flex items-center px-3 py-1 border border-gray-300 text-xs leading-5 font-medium rounded-md text-white hover:text-gray-100 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-blue-600 active:text-white transition ease-in-out duration-150"
                    >
                      Copy
                    </button>
                  </div>
                </dd>
              </div>
              <div
                class="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Status Order
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  <template v-if="dataSelected.status_order">
                    <span
                      v-if="dataSelected.status_order === 'Hold'"
                      class="bg-blue-400 px-2 py-1 text-white rounded font-semibold"
                      >{{ dataSelected.status_order }}</span
                    >
                    <span
                      v-if="dataSelected.status_order === 'Cancel'"
                      class="bg-red-400 px-2 py-1 text-white rounded font-semibold"
                      >{{ dataSelected.status_order }}</span
                    >
                    <span
                      v-if="dataSelected.status_order === 'Pending'"
                      class="bg-yellow-400 px-2 py-1 text-white rounded font-semibold"
                      >{{ dataSelected.status_order }}</span
                    >
                    <span
                      v-if="dataSelected.status_order === 'Manifest'"
                      class="bg-green-400 px-2 py-1 text-white rounded font-semibold"
                      >{{ dataSelected.status_order }}</span
                    >
                  </template>
                  <template v-else>
                    -
                  </template>
                </dd>
              </div>
              <div
                class="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Posisi Pesanan
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  <span v-if="dataSelected.position_order">
                    {{
                      dataSelected.position_order === "Agen"
                        ? "Agen/Kurir"
                        : dataSelected.position_order
                    }}
                  </span>
                </dd>
              </div>
              <div
                class="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Nama Pengirim
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  {{
                    dataSelected.sender_name ? dataSelected.sender_name : "-"
                  }}
                </dd>
              </div>
              <div
                class="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Alamat Pengirim
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  {{
                    dataSelected.sender_address
                      ? dataSelected.sender_address
                      : "-"
                  }}
                </dd>
              </div>
              <div
                class="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  No Handphone Pengirim
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  {{
                    dataSelected.sender_phone ? dataSelected.sender_phone : "-"
                  }}
                </dd>
              </div>
              <div
                class="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Nama Penerima
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  {{
                    dataSelected.recipient_name
                      ? dataSelected.recipient_name
                      : "-"
                  }}
                </dd>
              </div>
              <div
                class="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Alamat Penerima
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  {{
                    dataSelected.recipient_address
                      ? dataSelected.recipient_address
                      : "-"
                  }}
                </dd>
              </div>
              <div
                class="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Negara
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  {{
                    dataSelected.recipient_destination
                      ? dataSelected.recipient_destination
                      : "-"
                  }}
                </dd>
              </div>
              <div
                class="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Kode POS
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  {{
                    dataSelected.recipient_postal_code
                      ? dataSelected.recipient_postal_code
                      : "-"
                  }}
                </dd>
              </div>
              <div
                class="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  No Handphone Penerima
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  {{
                    dataSelected.recipient_phone
                      ? dataSelected.recipient_phone
                      : "-"
                  }}
                </dd>
              </div>
              <template v-if="profileData.role.role_name !== 'CS Pusat'">
                <div
                  class="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
                >
                  <dt class="text-xs font-medium text-gray-500">
                    Mitra Ekspedisi
                  </dt>
                  <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                    {{ dataSelected.courier ? dataSelected.courier : "-" }}
                  </dd>
                </div>
              </template>

              <div
                class="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  AWB No/No Resi
                </dt>
                <dd
                  class="mt-1 text-xs text-gray-900 font-semibold sm:mt-0 sm:col-span-2"
                >
                  {{
                    dataSelected.awb_no
                      ? dataSelected.awb_no
                      : "(Belum Diinput)"
                  }}
                </dd>
              </div>
              <div
                class="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Berat
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  <!-- <h4
                v-for="(item, index) in dataSelected.detail_volume"
                :key="index"
              >
                {{ item.berat ? item.berat + " Kg" : "-" }}
              </h4> -->
                  {{ dataSelected.weight ? dataSelected.weight + " kg" : "-" }}
                </dd>
              </div>
              <div
                class="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Jumlah Koli
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  {{ dataSelected.bag_amount ? dataSelected.bag_amount : "-" }}
                  <!-- {{ totalKoli ? totalKoli + " Kg" : "-" }} -->
                </dd>
              </div>
              <div
                class="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Jenis Layanan
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  {{
                    dataSelected.service_type ? dataSelected.service_type : "-"
                  }}
                </dd>
              </div>
              <div
                class="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Volume (cm)
                </dt>

                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  <template
                    v-if="
                      dataSelected.long &&
                        dataSelected.wide &&
                        dataSelected.height
                    "
                  >
                    {{ dataSelected.long ? dataSelected.long : "-" }}
                    x
                    {{ dataSelected.long ? dataSelected.wide : "-" }}
                    x
                    {{ dataSelected.long ? dataSelected.height : "-" }}
                  </template>
                  <template v-else>
                    <h4
                      v-for="(item, index) in dataSelected.detail_volume"
                      :key="index"
                    >
                      {{ item.panjang ? item.panjang : "-" }}
                      x
                      {{ item.lebar ? item.lebar : "-" }}
                      x
                      {{ item.tinggi ? item.tinggi : "-" }}
                    </h4>
                  </template>
                </dd>
              </div>
              <template v-if="profileData.role.role_name !== 'CS Pusat'">
                <div
                  class="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
                >
                  <dt class="text-xs font-medium text-gray-500">
                    Ongkos Kirim
                  </dt>
                  <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                    {{
                      dataSelected.shipment_fee
                        ? "Rp" + formatPrice(dataSelected.shipment_fee)
                        : "-"
                    }}
                  </dd>
                </div>
              </template>
              <div
                class="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Pickup
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  {{ dataSelected.pickup_by ? dataSelected.pickup_by : "-" }}
                </dd>
              </div>
              <div
                class="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Agen
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  {{
                    dataSelected.agen
                      ? dataSelected.agen.fullname
                      : dataSelected.agen_general
                  }}
                </dd>
              </div>
              <div
                class="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Deskripsi Paket
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  <h4
                    v-for="(item, index) in dataSelected.detail_item"
                    :key="index"
                  >
                    {{ item.code ? item.code : "" }}
                    {{ item.item_name ? item.item_name : "" }}
                    {{ item.qty ? item.qty : "" }}
                    {{ item.unit ? item.unit : "" }}
                    {{ item.total_value ? formatPrice(item.total_value) : "" }}
                  </h4>
                </dd>
              </div>
              <div
                class="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Tipe Pembayaran
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  {{
                    dataSelected.payment_type ? dataSelected.payment_type : "-"
                  }}
                </dd>
              </div>
              <div
                v-if="dataSelected.payment_type === 'Transfer'"
                class="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Tujuan Bank
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  {{ dataSelected.bank ? dataSelected.bank : "-" }}
                </dd>
              </div>
              <div
                v-if="dataSelected.payment_type === 'Transfer'"
                class="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Keterangan Pembayaran
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  {{
                    dataSelected.payment_info ? dataSelected.payment_info : "-"
                  }}
                </dd>
              </div>
              <template v-if="profileData.role.role_name !== 'CS Pusat'">
                <div
                  class="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
                >
                  <dt class="text-xs font-medium text-gray-500">
                    Total Bayar
                  </dt>
                  <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                    {{
                      dataSelected.amount_paid
                        ? "Rp" + formatPrice(dataSelected.amount_paid)
                        : "-"
                    }}
                  </dd>
                </div>
              </template>
              <div
                class="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Scan Barcode Oleh
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  {{
                    dataSelected.scanned_by
                      ? dataSelected.scanned_by.fullname
                      : "-"
                  }}
                </dd>
              </div>
              <div
                class="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
              >
                <dt class="text-xs font-medium text-gray-500">
                  Admin
                </dt>
                <dd class="mt-1 text-xs text-gray-900 sm:mt-0 sm:col-span-2">
                  {{
                    dataSelected.input_by ? dataSelected.input_by.fullname : "-"
                  }}
                </dd>
              </div>
            </dl>
          </detailDataModal>
        </transition>
      </div>
    </template>
  </layouts>
</template>

<script>
import layouts from "@/components/layouts";
import board from "@/components/international/board";
import detailDataModal from "@/components/datatables/detail_modal";
import zloading from "@/components/zloading";
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import { reactive, computed, ref } from "@vue/composition-api";
import {
  useInternationalOrdersWithFilter,
  useTotalOrderInternational,
  useTotalShipmentFee,
} from "@/composables/transaction/useTransaction";
import { useProfile } from "@/composables/auth/useAuth";
Vue.use(VueClipboard);

export default {
  components: {
    layouts,
    board,
    detailDataModal,
    zloading,
  },
  setup() {
    const listParams = reactive({
      page: 1,
      limit: 10,
      pagination: true,
      search: "",
      start_date: "",
      end_date: "",
      courier: "",
      destination: "",
      status_order: "",
      manifest_date: "",
      agen: "",
      admin: "",
      payment_method: "",
      search_no_order: "",
      search_awb_no: "",
      search_recipient_name: "",
      awb_filter: "awb_exist",
      branch: undefined,
      branch_mutiple: undefined,
      master_agen: undefined,
      input_by: undefined,
    });
    const listQuery = useInternationalOrdersWithFilter(
      computed(() => ({ ...listParams })),
      { keepPreviousData: true }
    );

    /* viewMode (List/Card) — slot queries hanya fire saat Card.
     * Synced dengan board via @viewModeChange. */
    const viewMode = ref("List");
    const slotEnabled = computed(() => viewMode.value === "Card");

    /* Five position-order slot queries — params per slot turunan dari listParams
     * dengan tambahan position_order_type. Gated dengan slotEnabled. */
    function makeSlotParams(type) {
      return computed(() => ({ ...listParams, position_order_type: type }));
    }
    const slotOpts = { enabled: slotEnabled, keepPreviousData: true };
    const agenQuery = useInternationalOrdersWithFilter(makeSlotParams("Agen"), slotOpts);
    const kurirQuery = useInternationalOrdersWithFilter(makeSlotParams("Kurir"), slotOpts);
    const cabangQuery = useInternationalOrdersWithFilter(makeSlotParams("Cabang"), slotOpts);
    const warehouseQuery = useInternationalOrdersWithFilter(makeSlotParams("Warehouse"), slotOpts);
    const mitraQuery = useInternationalOrdersWithFilter(makeSlotParams("Mitra"), slotOpts);

    const countParams = reactive({
      search: "",
      start_date: "",
      end_date: "",
      courier: "",
      destination: "",
      status_order: "",
      manifest_date: "",
      agen: "",
      admin: "",
      payment_method: "",
      search_no_order: "",
      search_awb_no: "",
      search_recipient_name: "",
      awb_filter: "awb_exist",
      branch: undefined,
      branch_mutiple: undefined,
      master_agen: undefined,
      input_by: undefined,
    });
    const countQuery = useTotalOrderInternational(
      computed(() => ({ ...countParams }))
    );
    const shipmentFeeQuery = useTotalShipmentFee(computed(() => ({})));
    const { data: serverProfile } = useProfile();

    return {
      listParams,
      countParams,
      serverProfile,
      viewMode,
      intqListData: listQuery.data,
      intqListIsLoading: listQuery.isLoading,
      intqListIsFetching: listQuery.isFetching,
      intqListRefetch: listQuery.refetch,
      intqAgenData: agenQuery.data,
      intqKurirData: kurirQuery.data,
      intqCabangData: cabangQuery.data,
      intqWarehouseData: warehouseQuery.data,
      intqMitraData: mitraQuery.data,
      intqCountData: countQuery.data,
      intqShipmentFeeData: shipmentFeeQuery.data,
    };
  },
  data() {
    return {
      /* Toggle Dialog */
      detailModal: false,
      /* Extra */
      dataSelected: [],
      detailVolume: [],
    };
  },
  computed: {
    profileData() {
      let profile = JSON.parse(
        window.localStorage.getItem("data-profile-jaskipin")
      );
      if (profile) {
        return profile;
      } else {
        return null;
      }
    },
    page: {
      get() { return this.listParams.page; },
      set(v) { this.listParams.page = v; },
    },
    limit: {
      get() { return this.listParams.limit; },
      set(v) { this.listParams.limit = v; },
    },
    search: {
      get() { return this.listParams.search; },
      set(v) { this.listParams.search = v; },
    },
    start_date: {
      get() { return this.listParams.start_date; },
      set(v) { this.listParams.start_date = v; },
    },
    end_date: {
      get() { return this.listParams.end_date; },
      set(v) { this.listParams.end_date = v; },
    },
    courier: {
      get() { return this.listParams.courier; },
      set(v) { this.listParams.courier = v; },
    },
    destination: {
      get() { return this.listParams.destination; },
      set(v) { this.listParams.destination = v; },
    },
    status_order: {
      get() { return this.listParams.status_order; },
      set(v) { this.listParams.status_order = v; },
    },
    manifest_date: {
      get() { return this.listParams.manifest_date; },
      set(v) { this.listParams.manifest_date = v; },
    },
    agen: {
      get() { return this.listParams.agen; },
      set(v) { this.listParams.agen = v; },
    },
    admin: {
      get() { return this.listParams.admin; },
      set(v) { this.listParams.admin = v; },
    },
    payment_method: {
      get() { return this.listParams.payment_method; },
      set(v) { this.listParams.payment_method = v; },
    },
    branch: {
      get() { return this.listParams.branch; },
      set(v) { this.listParams.branch = v; },
    },
    search_no_order: {
      get() { return this.listParams.search_no_order || ""; },
      set(v) { this.listParams.search_no_order = v; },
    },
    search_awb_no: {
      get() { return this.listParams.search_awb_no || ""; },
      set(v) { this.listParams.search_awb_no = v; },
    },
    search_recipient_name: {
      get() { return this.listParams.search_recipient_name || ""; },
      set(v) { this.listParams.search_recipient_name = v; },
    },
    data() {
      return this.intqListData || { data: [], meta: null };
    },
    dataAgen() {
      const raw = this.intqAgenData;
      return raw && raw.data ? raw.data : [];
    },
    dataKurir() {
      const raw = this.intqKurirData;
      return raw && raw.data ? raw.data : [];
    },
    dataCabang() {
      const raw = this.intqCabangData;
      return raw && raw.data ? raw.data : [];
    },
    dataWarehouse() {
      const raw = this.intqWarehouseData;
      return raw && raw.data ? raw.data : [];
    },
    dataMitra() {
      const raw = this.intqMitraData;
      return raw && raw.data ? raw.data : [];
    },
    totalOrder() {
      const raw = this.intqCountData;
      return raw && raw.data ? raw.data : {};
    },
    totalShipmentFee() {
      const raw = this.intqShipmentFeeData;
      return raw && raw.data ? raw.data : [];
    },
    loading() {
      return this.intqListIsLoading && !this.intqListData;
    },
    totalBerat() {
      const sum = this.dataSelected.detail_volume?.reduce((a, { berat }) => {
        return a + berat;
      }, 0);
      return sum;
    },

    totalKoli() {
      return this.dataSelected.detail_volume?.reduce((a, { koli }) => {
        return a + koli;
      }, 0);
    },
  },
  created() {
    /* Initiate Function — sync profile-derived filters & trigger refetch.
     * useTotalShipmentFee dipanggil otomatis di setup. */
    this.getListData(this.page, this.limit);
  },
  methods: {
    /*
     * Apply branch/master_agen filter dari profile ke listParams & countParams.
     */
    applyProfileFilter() {
      const profile = this.serverProfile || this.profileData || {};
      if (profile.type_user == "Supervisor") {
        const tb = profile.type_branch || [];
        const branchMutiple = Array.isArray(tb) ? tb.map((it) => it.value) : [];
        this.listParams.branch_mutiple = branchMutiple;
        this.countParams.branch_mutiple = branchMutiple;
        this.listParams.branch = undefined;
        this.countParams.branch = undefined;
      } else if (
        profile.type_user !== "Super Admin" &&
        profile.type_user !== "Gudang Pusat" &&
        profile.type_user !== "CS Pusat" &&
        profile.type_user !== "Finance" &&
        profile.type_user !== "Akunting" &&
        profile.type_user !== "Master Agen"
      ) {
        this.listParams.branch =
          profile.branch && profile.branch._id ? profile.branch._id : undefined;
        this.countParams.branch = this.listParams.branch;
        this.listParams.branch_mutiple = undefined;
        this.countParams.branch_mutiple = undefined;
      } else {
        let branchMutiple = [];
        if (this.branch && this.branch.length > 0) {
          this.branch.map((item) => {
            branchMutiple.push(item.value);
          });
        }
        this.listParams.branch_mutiple = branchMutiple;
        this.countParams.branch_mutiple = branchMutiple;
      }
      if (profile.type_user == "Master Agen") {
        this.listParams.master_agen = profile.id;
        this.listParams.input_by = profile.id;
        this.countParams.master_agen = profile.id;
        this.countParams.input_by = profile.id;
      } else {
        this.listParams.master_agen = undefined;
        this.listParams.input_by = undefined;
        this.countParams.master_agen = undefined;
        this.countParams.input_by = undefined;
      }
    },
    /*
     * Get Data Method — sinkron listParams/countParams lalu refetch.
     */
    async getListData(page, limit) {
      if (typeof page === "number") this.listParams.page = page;
      if (typeof limit === "number") this.listParams.limit = limit;
      this.listParams.search_no_order = (this.search_no_order || "").toUpperCase();
      this.listParams.search_awb_no = (this.search_awb_no || "").toUpperCase();
      this.applyProfileFilter();
      /* Sinkron countParams (kecuali page/limit) */
      this.countParams.search = this.listParams.search;
      this.countParams.start_date = this.listParams.start_date;
      this.countParams.end_date = this.listParams.end_date;
      this.countParams.courier = this.listParams.courier;
      this.countParams.destination = this.listParams.destination;
      this.countParams.status_order = this.listParams.status_order;
      this.countParams.manifest_date = this.listParams.manifest_date;
      this.countParams.agen = this.listParams.agen;
      this.countParams.admin = this.listParams.admin;
      this.countParams.payment_method = this.listParams.payment_method;
      this.countParams.search_no_order = this.listParams.search_no_order;
      this.countParams.search_awb_no = this.listParams.search_awb_no;
      this.countParams.search_recipient_name = this.listParams.search_recipient_name;
      try {
        await this.intqListRefetch();
      } catch (error) {
        console.log(error);
      }
    },
    /*
     * Pagination Handler Function
     */
    pageNavHandler(type) {
      switch (type) {
        case "previous":
          this.page -= 1;
          this.getListData(this.page, this.limit);
          break;
        case "next":
          this.page += 1;
          this.getListData(this.page, this.limit);
          break;
      }
    },
    /*
     * Search Function
     */
    tableInputSearchHandler(event) {
      const value = event.target.value; // ambil value dari form input search

      if (value === "") {
        this.search = ""; // Mengkosongkan kembali state querynya
        this.getListData(this.page, this.limit);
      } else {
        this.search = value;
        this.getListData(1, this.limit); // Ketika Filter Search dilakukan tidak bisa jika diset pagenya diatas 1 kalau hasil recordnya gak lebih dari limit/10 record
      }
    },
    /*
     * Get Detail Order Method
     */
    async detailOrder(value) {
      /* Empty Data Selected */
      this.dataSelected = [];

      /* Set Data Selected & Show Detail Modal */
      this.dataSelected = value;
      this.detailModal = true;
    },
    /* Helpers */
    async refreshData() {
      await this.getListData(this.page, this.limit);
    },
    resetData() {
      this.search = "";
      this.start_date = "";
      this.end_date = "";
      this.courier = "";
      this.destination = "";
      this.status_order = "";
      this.manifest_date = "";
      this.agen = "";
      this.admin = "";
      this.payment_method = "";
      this.branch = "";
      this.search_no_order = "";
      this.search_awb_no = "";
      this.search_recipient_name = "";
      this.refreshData();
    },
    filterStartDate(value) {
      this.start_date = value;
      this.refreshData();
    },
    filterEndDate(value) {
      this.end_date = value;
      this.refreshData();
    },
    filterCourier(value) {
      this.courier = value;
      this.refreshData();
    },
    filterDestination(value) {
      this.destination = value;
      this.refreshData();
    },
    filterStatusOrder(value) {
      this.status_order = value;
      this.refreshData();
    },
    filterLimitOrder(value) {
      this.limit = value;
      this.refreshData();
    },
    filterManifestDate(value) {
      this.manifest_date = value;
      this.refreshData();
    },
    filterAgen(value) {
      this.agen = value;
      this.refreshData();
    },
    filterAdmin(value) {
      this.admin = value;
      this.refreshData();
    },
    filterPaymentMethod(value) {
      this.payment_method = value;
      this.refreshData();
    },
    filterBranch(value) {
      this.branch = value;
      this.refreshData();
    },
    searchNoOrder(value) {
      this.search_no_order = value;
      this.refreshData();
    },
    searchAWBNo(value) {
      this.search_awb_no = value;
      this.refreshData();
    },
    searchAllQuery(value) {
      this.search = value;
      this.refreshData();
    },
    selectRangeDate(value) {
      let date = new Date();
      let firstDay;
      let lastDay;

      switch (value) {
        case "Hari Ini":
          firstDay = date;
          lastDay = date;
          break;

        case "Bulan Ini":
          firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
          lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          break;

        case "Tahun Ini":
          firstDay = new Date(date.getFullYear(), 0, 1);
          lastDay = new Date(date.getFullYear(), 11, 31);
          break;

        case "7 Hari Terakhir":
          firstDay = new Date(date.setDate(date.getDate() - 7));
          lastDay = new Date();
          break;

        case "30 Hari Terakhir":
          firstDay = new Date(date.setDate(date.getDate() - 30));
          lastDay = new Date();
          break;

        default:
          firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
          lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          break;
      }

      this.start_date = this.convertDate(firstDay);
      this.end_date = this.convertDate(lastDay);

      /* Refresh Data */
      this.refreshData();
    },
    formatPrice(number) {
      var rupiah = "";
      var angkarev = number
        .toString()
        .split("")
        .reverse()
        .join("");
      for (var i = 0; i < angkarev.length; i++)
        if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
      return rupiah
        .split("", rupiah.length - 1)
        .reverse()
        .join("");
    },
    formatDate(value) {
      let options = { year: "numeric", month: "long", day: "numeric" };
      let date = new Date(value).toLocaleString("id-ID", options);
      return date;
    },
    convertDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    /* getTotalOrder & getTotalShipmentFee dihapus — sudah dipindah ke
     * useTotalOrderInternational & useTotalShipmentFee composable. */
    onCopyShipmentNumber() {
      alert("No order sudah dicopy");
    },
    onErrorShipmentNumber() {
      alert("Gagal dicopy");
    },
  },
};
</script>

<style scoped></style>
